var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.75 18.5C12.074 18.4843 14.3063 17.5914 16 16L21 21L16 16C17.553 14.2821 18.4398 12.065 18.5 9.75C18.5 8.01942 17.9868 6.32769 17.0254 4.88876C16.0639 3.44983 14.6973 2.32832 13.0985 1.66606C11.4996 1.00379 9.7403 0.830512 8.04296 1.16813C6.34563 1.50575 4.78653 2.33911 3.56282 3.56282C2.33911 4.78653 1.50575 6.34563 1.16813 8.04296C0.830512 9.7403 1.00379 11.4996 1.66606 13.0985C2.32832 14.6973 3.44983 16.0639 4.88876 17.0254C6.32769 17.9868 8.01942 18.5 9.75 18.5V18.5Z",
    stroke: "#717171",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.d9151b027075ea1608d9469773c0bee4.svg";
export { ForwardRef as ReactComponent };